import React from 'react'
import PropTypes from 'prop-types'
import URLSearchParams from 'url-search-params'
import { concat } from 'ramda'
import cn from 'classnames'

import './brandingStatementWidget.scss'

const getHrefParam = (href, param) => {
  if (!href) {
    return undefined
  }
  const params = new URLSearchParams(href)
  return params.get(param)
}

const triggerLoginHandler = (e) => {
  if (e.target.getAttribute('href') === '#log-in') {
    const loginLink = document.querySelector('.account-dropdown .log-in')

    if (loginLink) {
      e.preventDefault()
      loginLink.click()
    }
  }
  if (location.href.includes('&isAutocomplete=true')) {
    history.replaceState({}, null, location.href.split('&isAutocomplete=true')[0]);
  }
  if (e.target.getAttribute('href') === '#change-my-date-btn') {
    e.preventDefault()
    const dateLink = document.querySelector('.search-filters.bf-first-step .search-filter-button .search-filter-button__label')

    if (dateLink) {
      dateLink.click()
    }
  }

  if (e.target.getAttribute('href') === '#change-my-acommodation-btn') {
    e.preventDefault()
    const editSearch = document.querySelector('.header-search-editable .header-search-editable__edit')

    if (editSearch) {
      editSearch.click()
    }
  }
}

const BrandingWidget = ({
  content,
  image,
  href,
  hotelsCount,
  isOffers,
}) => (
  <div
    className={cn('branding-statement-widget', { isOffers })}
    geo_code={getHrefParam(href, 'geoCode')}
    geo_type={getHrefParam(href, 'geoType')}
  >
    <div
      className="branding-statement__holder"
    >
    {href
      ? (
        <div
          role="button"
          tabIndex="0"
          onKeyDown={() => {}}
          onClick={(event) => {
            event.preventDefault()
            if (event.target.getAttribute('href') !== '#log-in') {
              window.location = concat(href, window.location.search.replace('?', '&'))
            }
          }}
          className="branding-statement"
          style={{ backgroundImage: `url(${image})` }}
        >
          <div className="branding-statement__logo" />
          <div
            onKeyDown={() => {}}
            role="button"
            tabIndex="0"
            onClick={triggerLoginHandler}
            className="branding-statement__text wysiwyg-holder"
            dangerouslySetInnerHTML={{ __html: `${content} (${hotelsCount})` }}
          />
        </div>
      ) : (
        <div
          className="branding-statement"
          style={{ backgroundImage: `url(${image})` }}
        >
          <div className="branding-statement__logo" />
          <div
            onKeyDown={() => {}}
            role="button"
            tabIndex="0"
            onClick={triggerLoginHandler}
            className="branding-statement__text wysiwyg-holder"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      )}
    </div>
  </div>
)

BrandingWidget.propTypes = {
  content: PropTypes.string,
  image: PropTypes.string,
  href: PropTypes.string,
  hotelsCount: PropTypes.string,
  isOffers: PropTypes.bool,
}

BrandingWidget.defaultProps = {
  content: '',
  image: '',
  href: null,
  hotelsCount: '',
  isOffers: false,
}

export default BrandingWidget
